export default {
  login: {
    pageTitle: 'Connexion',
    title: 'Salut. Connectons-nous !',
    emailLoginTitle: 'Se connecter avec un e-mail',
    subtitle: 'Se connecter avec',
    helperText:
      "Vous n'avez pas de compte ? Contactez votre gestionnaire Compass ou votre CDL pour en créer un.",
    orHelperText: 'ou',
    buttons: {
      ssoLogin: 'Utilisez votre identifiant Compass',
      userLogin: 'Se connecter avec un e-mail',
      userLoginBack: 'Retour',
    },
    info: {
      warnInfo: 'Certaines fonctionnalités ne sont pas disponibles avec la connexion par e-mail',
      ssoError:
        "Nous n'avons pas pu vous connecter avec votre compte SSO. Veuillez réessayer ou contacter le support si le problème persiste.",
      line1: 'Pas de compte ?',
      line2: 'Contactez votre Responsable de la Stratégie Numérique',
    },
    infoPassword: {
      subtitle: 'Entrez votre e-mail et votre mot de passe',
      line1: 'Mot de passe oublié ?',
      line2: 'Contactez votre Responsable de la Stratégie Numérique',
      authenticating: 'Veuillez patienter. Connexion en cours...',
    },
    form: {
      fields: {
        email: 'E-mail',
        password: 'Mot de passe',
      },
      buttons: {
        p2Login: 'Se connecter',
      },
      errors: {
        credentialsNotMatched: "Votre nom d'utilisateur ou vos identifiants ne correspondent pas",
        unexpectedError: 'Une erreur inattendue est survenue. Veuillez contacter le support.',
      },
    },
    permissionDenied: "Vous n'avez pas les autorisations pour vous connecter",
  },
  passwordReset: {
    pageTitle: 'Réinitialiser le mot de passe',
    forgotPasswordTitle: 'Mot de passe oublié ?',
    resetPasswordTitle: 'Réinitialiser le mot de passe',
    orHelperText: 'Ou',
    requirement: 'Exigence',
    buttons: {
      userLogin: 'Utilisez votre identifiant Compass pour vous connecter',
      goBackChangeEmail: "Retour pour changer l'adresse e-mail",
      sendResetLink: 'Envoyer le lien de mot de passe',
      resendResetLink: 'Renvoyer le lien de mot de passe',
      resetPassword: 'Réinitialiser le mot de passe',
    },
    info: {
      skipPasswordResetNextTime:
        'Voulez-vous ignorer la réinitialisation du mot de passe la prochaine fois ?',
      emailResetInstructions:
        'Nous vous enverrons par e-mail les instructions pour le réinitialiser',
      sentInstructionsTo: 'Nous avons envoyé les instructions à',
      waitForArrivalCheckSpam:
        "Veuillez attendre 2 minutes pour qu'il arrive. Si ce n'est pas le cas, vérifiez votre dossier spam.",
      sendingEmail: "Envoi de l'e-mail de réinitialisation...",
      checkYourEmail: 'Vérifiez votre e-mail',
    },
    form: {
      fields: {
        email: 'E-mail',
        newPassword: 'Nouveau mot de passe',
        confirmNewPassword: 'Confirmer le nouveau mot de passe',
      },
      placeholder: {
        newPassword: 'Entrez votre nouveau mot de passe',
        confirmNewPassword: 'Répétez votre nouveau mot de passe',
      },
      validation: {
        minimumCharacters: 'Minimum 15 caractères',
        oneUpperCase: 'Au moins un caractère majuscule',
        oneLowerCase: 'Au moins un caractère minuscule',
        numberOrSpecialCharacter: 'Un chiffre ou un caractère spécial',
        passwordsMatch: 'Les mots de passe correspondent',
        passwordsNotMatch: 'Les mots de passe ne correspondent pas',
      },
      success: {
        emailSent: "L'e-mail de réinitialisation du mot de passe a été envoyé avec succès !",
        passwordReset: 'Votre mot de passe a été réinitialisé',
      },
      errors: {
        unexpectedError: 'Une erreur inattendue est survenue. Veuillez contacter le support.',
      },
    },
  },
};
